import { render, staticRenderFns } from "./TerminalsContract.vue?vue&type=template&id=3be84692&"
import script from "./TerminalsContract.vue?vue&type=script&lang=js&"
export * from "./TerminalsContract.vue?vue&type=script&lang=js&"
import style0 from "./TerminalsContract.vue?vue&type=style&index=0&id=3be84692&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports